import { render, staticRenderFns } from "./CartWidget.vue?vue&type=template&id=4ccdab84"
import script from "./CartWidget.vue?vue&type=script&lang=ts"
export * from "./CartWidget.vue?vue&type=script&lang=ts"
import style0 from "./CartWidget.vue?vue&type=style&index=0&id=4ccdab84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports